import React from "react";
import { UiStatusService } from "./UiStatusService";
import { getUiStatusContext } from "./UiStatusContext";
interface Props {
  service: UiStatusService;
}
export const UiStatusProvider: React.FC<Props> = ({ children, service }) => {
  const UiStatusContext = getUiStatusContext();
  return (
    <UiStatusContext.Provider value={service}>
      {children}
    </UiStatusContext.Provider>
  );
};
